import React from "react";
import { Route, Redirect } from "react-router-dom";
import { usePermissions } from "./PermissionContext";

const RestrictedRoute = ({ permission, children, ...rest }) => {
  const { permissions = [], loading, userInfo } = usePermissions();

  if (loading) {
    return <div>Loading...</div>; // or spinner
  }

  const isSuperAdmin = userInfo?.role_permission?.[0]?.role === "super admin";

  if (isSuperAdmin) {
    // If user is a super admin, do not restrict the route
    return <Route {...rest}>{children}</Route>;
  }

  const hasAccess = permissions.some(
    (p) => p.permission_name === permission && p.is_accessible
  );
  const matchedPermission = permissions.find(
    (p) => p.permission_name === permission && p.is_accessible
  );

  console.log("permissions....", permissions);
  console.log("Matched permission:", matchedPermission);

  return (
    <Route
      {...rest}
      render={() =>
        hasAccess ? children : <Redirect to="/AccessDeniedPage" />
      }
    />
  );
};

export default RestrictedRoute;
